import React from 'react';
import {
  PickersTextField as MUIPickersTextField,
  PickersTextFieldProps as MUIPickersTextFieldProps,
} from '@mui/x-date-pickers/PickersTextField';

import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

const styles = {
  textField: {
    fontSize: fonts.md,
  },
  label: {
    color: colors.neutral.gray,
  },
};

export const PickerTextField = (props: any, ref: React.Ref<HTMLDivElement>) => {
  const { slotProps = {}, ...data } = props;
  const MUIProps: MUIPickersTextFieldProps = data;

  return (
    <MUIPickersTextField
      {...MUIProps}
      ref={ref}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps.input,
          sx: {
            '&.Mui-disabled': { color: colors.neutral.gray },
            ...styles.textField,
            ...slotProps.input?.sx,
          },
        },
        inputLabel: {
          ...slotProps.inputLabel,
          sx: { ...styles.label, ...slotProps.inputLabel?.sx },
          shrink: true,
        },
      }}
      variant="standard"
    />
  );
};

export default React.forwardRef(PickerTextField);
